import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Link from 'react-router-dom/Link';

const WrappedLink = (props) => (
  <Link {...props} />
);

export default (props) => (
  <IconButton {...props} component={WrappedLink} />
);



// WEBPACK FOOTER //
// ./src/components/common/IconButtonLink/index.js